<template>
  <router-view />
</template>

<script>
export default {};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/templates/Post.vue